export default {
    generateContentModal: {
        title: 'Gerar Conteúdo',
        type: 'Tipo',
        typePlaceholder: 'Selecionar tipo',
        typeEmptyError: 'Por favor, selecione o tipo',
        context: 'Contexto',
        contextPlaceholder: 'Selecionar contexto',
        contextEmptyError: 'Por favor, selecione o contexto',
        contentTitle: 'Título do conteúdo',
        contentTitlePlaceholder: 'Adicione um tema para seu conteúdo',
        contentTitleEmptyError: 'Digite o título',
        contentTitleInvalidError: 'Digite um título válido',
        contentTitleNumberError: 'Por favor, insira um título que comece com uma letra',
        description: 'Forneça uma breve descrição do conteúdo',
        descriptionPlaceholder: 'Escreva uma descrição para seu conteúdo em 2-3 linhas',
        descriptionEmptyError: 'Forneça a descrição',
        descriptionInvalidError: 'Forneça uma descrição válida',
        addKeywords: 'Adicionar palavras-chave',
        addKeywordsEmptyError: 'Digite as palavras-chave',
        writingTone: 'Tom de escrita',
        writingTonePlaceholder: 'Selecionar tom de escrita',
        writingToneEmptyError: 'Por favor, selecione o tom de escrita',
        numberOfVariations: 'Número de variações',
        numberOfVariationsEmptyError: 'Selecione o número de variações',
        numberOfVariationsInvalidError: 'Você pode gerar no máximo 5 e no mínimo 1 variação',
        generate: 'Gerar',
        additionalOptions: 'Opções adicionais',
        clear: 'Limpar',
        writingToneOptions: {
            funny: 'Engraçado',
            casual: 'Informal',
            excited: 'Animado',
            professional: 'Profissional',
            witty: 'Espirituoso',
            sarcastic: 'Sarcástico',
            feminine: 'Feminino',
            masculine: 'Masculino',
            bold: 'Ousado',
            dramatic: 'Dramático',
            grumpy: 'Mal-humorado',
            secretive: 'Sigiloso',
            respectful: 'Respeitoso',
            persuasive: 'Persuasivo',
        },
        contextOptions: {
            promotional: 'Promocional',
            introduction: 'Introdução',
            couponDiscount: 'Cupom/Desconto',
            recurringNewsletter: 'Newsletter Recorrente',
            testimonial: 'Depoimento',
            coldOutreach: 'Prospecção Fria',
            contentGiveaway: 'Conteúdo/Sorteio',
            other: 'Outro',
        },
        typeOptions: {
            outline: 'Esboço',
            introduction: 'Introdução',
            section: 'Seção',
        },
        customLengthOfContentPlaceholder: 'Antall ord (maks 900)',
        lengthOfContentPlaceholder: 'Velg innholdslengde',
        lengthOfContent: 'Lengden på innholdet',
        customLengthOfContent: '',
        smallContent: 'Liten',
        mediumContent: 'Médio',
        largeContent: 'Grande',
        customContentLength: 'Tilpasset lengde (50 - 900 ord)',
        lengthOfContentError: '',
        customLengthError: 'Feil verdi',
        lengthOfContentTooltip: 'Defina o tamanho do conteúdo a ser gerado com base na descrição das instruções',
    },
};
